import can from "../helpers/can";
import store from "../core/services/store/index";
import {VERIFY_AUTH} from "../core/services/store/auth.module";

export default function checkPermissions({next, to, from, router}) {
    const requiredPermissions = to.meta.permissions;

    if (!from.name){
        store.dispatch(VERIFY_AUTH).then(() => {
                const canEnter = can(requiredPermissions);

                if (canEnter) {
                    return next();
                }

            return next();
            });

    } else {
        const canEnter = can(requiredPermissions);
        if (canEnter) {
            return next();
        }
        return router.push({name: 'dashboard'});
    }
}